module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Join.15ba308c.svg";